import * as CollapsiblePrimitive from '@radix-ui/react-collapsible'
import { ChevronRight } from 'lucide-react'
import { forwardRef } from 'react'
import { Button } from './button'

const Collapsible = CollapsiblePrimitive.Root

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger

const CollapsibleContent = CollapsiblePrimitive.CollapsibleContent

export const CollapsibleTriggerButton = forwardRef<
	HTMLButtonElement,
	React.HTMLAttributes<HTMLButtonElement> & {
		isOpen?: boolean
		openText?: string
		closedText?: string
	}
>(
	(
		{ children, isOpen, openText = 'Hide', closedText = 'Show', ...props },
		ref,
	) => {
		return (
			<CollapsibleTrigger asChild {...props} ref={ref}>
				<Button variant="outline">
					{isOpen ? openText : closedText}
					<ChevronRight className="ml-auto transition-transform group-data-[state=open]/collapsible:rotate-90" />
				</Button>
			</CollapsibleTrigger>
		)
	},
)

export { Collapsible, CollapsibleTrigger, CollapsibleContent }
